export const ConfirmSelectors = {
    IsOpen: (state) => state.Confirm.isOpen,
    Options: (state) => state.Confirm.options,
};
